{
  "sourcing": {
    "formExamples": {
      "title": "مثال: مستلزمات مكتبية لمنطقة الاستقبال"
    },
    "queueSearch": {
      "label": "ابحث بالرقم أو العنوان أو السبب",
      "placeholder": "الرقم أو العنوان أو السبب"
    },
    "openNeedsSupplier": "اختر مورداً واحداً على الأقل لفتح طلب العروض.",
    "deadlineHintZone": "يسري بعد فتح الطلب للموردين. المنطقة الزمنية: {{zone}}."
  }
}
